import PrismicDOM from "prismic-dom";
import { linkResolver } from "../utils/link-resolver";
import { PrismicTypeToHref } from "../utils/prismic-type-to-href";

// link: PrismicLink
const PrismicToLink = link => {
  const { link_type, url } = link;
  switch (link_type) {
    case "Document":
      return {
        internal: true,
        href: PrismicTypeToHref(link.type),
        as: `${PrismicDOM.Link.url(link, linkResolver)}`
      };
    case "Any":
      return null;
    default:
      return { internal: false, href: url };
  }
};

export { PrismicToLink };
